import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { VerifyEmailPayload } from '../../../../types/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postVerifyEmail } from '../../requests/postVerifyEmail';

type VerifyEmailVariables = {
  data: VerifyEmailPayload;
  headers?: Record<string, string>;
  params?: RequestConfig['params'];
};

export const useVerifyEmail = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ data, headers, params }: VerifyEmailVariables) =>
      postVerifyEmail(constructPost, data, headers, params),
  });
  return { verifyEmail: mutateAsync, ...rest };
};
